import { useEffect, useState } from 'react';
import { hrAPI } from '../lib/api';

/**
 * Lightweight client-side HR permissions hook. The backend is always the
 * source of truth — this just gates UI nav / buttons.
 */
export const useHrPermissions = () => {
  const [perms, setPerms] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    hrAPI.permissions()
      .then(r => setPerms(r.data))
      .catch(() => setPerms(null))
      .finally(() => setLoading(false));
  }, []);

  return { perms, loading };
};

export default useHrPermissions;
